module.exports = __webpack_public_path__ + "img/bmviplogo.cc55752a.png";